import { getCalcInputState } from "../../../../../utils/selectors";
import { rightHipSlice } from "./slice";

export const getRightHipState = state => getCalcInputState(state)[rightHipSlice.name];